import { Span } from '@/core/tamagoshiTailwind/components/Typography/Typography';
import { ChevronRightIcon } from '@/core/tamagoshiTailwind/icons/ChevronRightIcon';
import {
  deliveryAndReturns,
  optionsAvailable,
} from '@/domains/productDiscovery/ProductPage/common/modules/Delivery/translations';
import { useSidePanel } from '@/domains/productDiscovery/ProductPage/hooks/useSidePanel';
import { useDeliveryState } from '@/productDiscovery/ProductPage/common/modules/Delivery/delivery.ducks';

import { DeliverySectionButtonSkeleton } from './DeliverySectionButtonSkeleton';
import { DeliveryWordingRevamp } from './DeliveryWordingRevamp';

export const DeliverySectionButton = () => {
  const { goToDeliveryAndReturns } = useSidePanel();

  const {
    offers: deliveryOffers,
    fetching: fetchingDelivery,
    fetched: fetchedDelivery,
  } = useDeliveryState();

  if (fetchingDelivery || (!fetchedDelivery && !fetchingDelivery))
    return <DeliverySectionButtonSkeleton />;

  if (deliveryOffers?.length === 0) return null;

  return (
    <button
      className="flex min-h-[64px] w-full flex-1 flex-col items-start
        justify-center gap-xs border-b border-foundation-primary
        bg-foundation-inverted p-m text-foundation-primary desktop:px-0"
      onClick={goToDeliveryAndReturns}
    >
      <div className="flex w-full justify-between">
        <Span
          scale="body1"
          weight="semibold"
          className="line-clamp-2 text-left"
        >
          {deliveryAndReturns}
        </Span>
        <div className="flex flex-initial items-center gap-xs">
          {deliveryOffers.length > 1 && (
            <Span scale="body2">
              {optionsAvailable.format({
                offers: deliveryOffers.length,
              })}
            </Span>
          )}
          <ChevronRightIcon />
        </div>
      </div>
      <DeliveryWordingRevamp offer={deliveryOffers[0]} />
    </button>
  );
};
